import React, { useState, useEffect } from 'react';
import styles from '../../styles/ConceptosCobroStyles/ConceptosCobro.module.css';
import { getCampus } from '../../api/campus';
import { getCycles } from '../../api/ciclosEscolares';

function FilterSection() {
  const [selectedCampus, setSelectedCampus] = useState('');
  const [selectedCiclo, setSelectedCiclo] = useState('');
  const [campusList, setCampusList] = useState([]);
  const [ciclosList, setCiclosList] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      try {
        const [campusData, ciclosData] = await Promise.all([
          getCampus(),
          getCycles()
        ]);
        setCampusList(campusData);
        setCiclosList(ciclosData);
        
        // Establecer ciclo más reciente como default
        if (ciclosData && ciclosData.length > 0) {
          const cicloMasReciente = ciclosData[0]; // Backend devuelve ordenado DESC
          setSelectedCiclo(cicloMasReciente.id || cicloMasReciente.id_ciclo_escolar);
        }
      } catch (err) {
        console.error('Error al cargar datos:', err);
      }
    };
    loadData();
  }, []);

  return (
    <div className={styles.filterSection}>
      <div className={styles.filterGroup}>
        <label className={styles.filterLabel}>Campus</label>
        <div className={styles.filterDropdown}>
          <select 
            value={selectedCampus}
            onChange={(e) => setSelectedCampus(e.target.value)}
            className={styles.filterSelect}
          >
            <option value="">Todos los campus</option>
            {campusList.map((campus) => (
              <option key={campus.id} value={campus.id}>
                {campus.nombre}
              </option>
            ))}
          </select>
          <div className={styles.dropdownArrow}>▼</div>
        </div>
      </div>

      <div className={styles.filterGroup}>
        <label className={styles.filterLabel}>Ciclo Escolar</label>
        <div className={styles.filterDropdown}>
          <select 
            value={selectedCiclo}
            onChange={(e) => setSelectedCiclo(e.target.value)}
            className={styles.filterSelect}
          >
            <option value="">Todos los ciclos</option>
            {ciclosList.map((ciclo) => (
              <option key={ciclo.id} value={ciclo.id}>
                {ciclo.nombre_ciclo || ciclo.name}
              </option>
            ))}
          </select>
          <div className={styles.dropdownArrow}>▼</div>
        </div>
      </div>
    </div>
  );
}

export default FilterSection;
